



































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { tenantService } from '@/shared';
import { Tenant } from '@/models/admin/tenant';
import {
    VHeaders,
    PaginationModel,
} from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { GetTenantsResponse } from '@/Alynk.dtos';
import { IDialogOption } from '@/models/dialog';
import {getTenantListHeaders} from '@/views/admin/tenant/tenant';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import( '@/components/common/app.dialog.vue'),
    },
})
export default class TenantListPage extends Base {
    public pagedTenant: Tenant[] = [];
    public pagination = new PaginationModel('name');

    public flags = {
        loading: false,
    };
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('dialogSettings.title') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: this.$parent.$t('dialogSettings.btntxtAgree') as string },
        onAction: (): void => {
            this.deleteTenant();
        },
    };

    public tenantToDelete: Tenant = {
        id: 0,
        name: '',
        code: '',
        isEnabled: true
    };
    public headers: VHeaders[] = getTenantListHeaders(this);
    public actions: any[] = [];
    public callMethod(methodName): void {
        if (methodName === 'addTenant') {
            this.$router.push({ name: 'admin.tenants.add' });
        }
    }
    public mounted() {
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setActions();
        this.getTenants();
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: 'Add Tenant', disabled: false, visible: true, class: 'btn', label: 'Add Tenant', click: 'addTenant', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'tenant');
    }
    public setActions() {
        this.actions = [
            {
                type: 'button',
                icon: 'fas fa-edit',
                title: this.$t('tenants.tenantGridHeaders.gridAction.edit') as string,
                color: 'primary',
                action: (model: Tenant) => {
                    this.addOrUpdateLink(model);
                },
            },
            {
                type: 'button',
                icon: 'fas fa-trash-alt',
                title: this.$t('tenants.tenantGridHeaders.gridAction.delete') as string,
                color: 'error',
                visible: () => {
                    return false;
                },
                action: (model: Tenant) => {
                    this.confirmDelete(model);
                },
            },
        ];
    }

    public async getTenants(): Promise<void> {
        try {
            this.flags.loading = true;
            const response = await tenantService.getAllAsync();
            this.pagedTenant = response.results;
            this.pagination.totalItems = response.total;
        } finally {
            this.flags.loading = false;
        }
    }
    public pageChanged(paging: any) {
        this.pagination = paging;
    }

    public confirmDelete(item: Tenant): void {
        this.deleteDialog.model = true;
        this.tenantToDelete = item;
    }
    public async deleteTenant(): Promise<void> {
        try {
            await tenantService.deleteAsync(this.tenantToDelete.id);
            this.showAlert(true, this.$t('tenants.alertDeleteTenant'));
            this.getTenants();
        } finally {
            this.deleteDialog.model = false;
        }
    }
    public addOrUpdateLink(model: Tenant): void {
        if (model) {
            this.$router.push({
                name: 'admin.tenants.edit',
                params: { id: model.id.toString() },
            });
        } else { this.$router.push({ name: 'admin.tenants.add' }); }
    }
}
